import { DeviceInfoModel, SettingsModel, UserModel } from 'constants/types'

/**
 * 로그인
 * @param user
 */
export const setCurrentUser = (user: UserModel) => {
	try {
		if (user) {
			localStorage.setItem(
				`${process.env.REACT_APP_USER_STORAGE_NAME}`,
				JSON.stringify(user)
			)
		} else {
			localStorage.removeItem(`${process.env.REACT_APP_USER_STORAGE_NAME}`)
		}
	} catch (error) {
		console.log(`${process.env.REACT_APP_USER_STORAGE_NAME} ERROR`, error)
	}
}

/**
 * 로그아웃
 */
export const removeCurrentUser = () => {
	localStorage.removeItem(`${process.env.REACT_APP_USER_STORAGE_NAME}`)
}

/**
 * 사용자 정보 호출
 * @returns
 */
export const getCurrentUser = () => {
	let user: any = ''
	try {
		user =
			localStorage.getItem(`${process.env.REACT_APP_USER_STORAGE_NAME}`) != null
				? JSON.parse(
						localStorage.getItem(`${process.env.REACT_APP_USER_STORAGE_NAME}`) || ''
				  )
				: null
	} catch (error) {
		console.log(`${process.env.REACT_APP_USER_STORAGE_NAME} ERROR`, error)
		user = null
	}
	return user
}

/**
 * 장치정보 저장
 * @param deviceInfo
 */
export const setUserDeviceInfo = (deviceInfo: DeviceInfoModel) => {
	try {
		if (deviceInfo) {
			localStorage.setItem(
				`${process.env.REACT_APP_DEVICE_STORAGE_NAME}`,
				JSON.stringify(deviceInfo)
			)
		} else {
			localStorage.removeItem(`${process.env.REACT_APP_DEVICE_STORAGE_NAME}`)
		}
	} catch (error) {
		console.log(`${process.env.REACT_APP_DEVICE_STORAGE_NAME} ERROR`, error)
	}
}

/**
 * 장치정보 호출
 * @returns
 */
export const getUserDeviceInfo = () => {
	let deviceInfo: any = ''
	try {
		deviceInfo =
			localStorage.getItem(`${process.env.REACT_APP_DEVICE_STORAGE_NAME}`) != null
				? JSON.parse(
						localStorage.getItem(`${process.env.REACT_APP_DEVICE_STORAGE_NAME}`) || ''
				  )
				: null
	} catch (error) {
		console.log(`${process.env.REACT_APP_DEVICE_STORAGE_NAME} ERROR`, error)
		deviceInfo = null
	}
	return deviceInfo
}

/**
 * 장치정보 삭제
 */
export const removeUserDeviceInfo = () => {
	localStorage.removeItem(`${process.env.REACT_APP_DEVICE_STORAGE_NAME}`)
}

/**
 * 환경설정 저장
 * @param settings
 */
export const setSettings = (settings: SettingsModel) => {
	try {
		if (settings) {
			localStorage.setItem(
				`${process.env.REACT_APP_SETTINGS_STORAGE_NAME}`,
				JSON.stringify(settings)
			)
		} else {
			localStorage.removeItem(`${process.env.REACT_APP_SETTINGS_STORAGE_NAME}`)
		}
	} catch (error) {
		console.log(`${process.env.REACT_APP_SETTINGS_STORAGE_NAME} ERROR`, error)
	}
}

/**
 * 환경설정 호출
 * @returns
 */
export const getSettings = () => {
	let settings: SettingsModel = {
		desnse: 'compact',
		row: 100,
		notShowToday: false,
		todayString: '',
		popupCount: 0,
	}
	try {
		settings =
			localStorage.getItem(`${process.env.REACT_APP_SETTINGS_STORAGE_NAME}`) !=
			null
				? JSON.parse(
						localStorage.getItem(`${process.env.REACT_APP_SETTINGS_STORAGE_NAME}`) ||
							''
				  )
				: { desnse: 'compact', row: 100, notShowToday: false, todayString: '' }
	} catch (error) {
		settings = {
			desnse: 'compact',
			row: 100,
			notShowToday: false,
			todayString: '',
			popupCount: 0,
		}
	}
	return settings
}

/**
 * 환경설정 삭제
 */
export const removeSettings = () => {
	localStorage.removeItem(`${process.env.REACT_APP_SETTINGS_STORAGE_NAME}`)
}
